import {
  EnvironmentProviders,
  inject,
  makeEnvironmentProviders,
  provideAppInitializer,
} from '@angular/core';
import { provideState } from '@ngrx/store';
import { provideEffects } from '@ngrx/effects';
import {
  APPLICATION_FEATURE_KEY,
  applicationReducer,
} from './+state/application/application.reducer';
import { ApplicationEffects } from './+state/application/application.effects';
import { ApplicationFacade } from './+state/application/application.facade';

export function provideApplicationStore(): EnvironmentProviders {
  return makeEnvironmentProviders([
    provideAppInitializer(() => {
      const applicationFacade: ApplicationFacade = inject(ApplicationFacade);
      applicationFacade.init();
    }),
    provideState(APPLICATION_FEATURE_KEY, applicationReducer),
    provideEffects(ApplicationEffects),
  ]);
}
